import React, { useState } from "react";

import { InfoWindow, Marker, OverlayView } from "@react-google-maps/api";
import employeeIcon from "../../img/user.png";
import { height } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import "../Dashboard/Dashboard.css";


const UserWithLabel = ({ user, isEmployee, isClient, isDashboard }) => {
  console.log(user)
  const [selectId, setSelectId] = useState(null);
  const [open, setOpen] = useState(true);
  // const handleActiveMarker = (marker) => {
  //   if (marker === activeMarker) {
  //     return;
  //   }
  //   setActiveMarker(marker);
  // };
  const onLoadInfo = (infoWindow) => {
    //console.log(infoWindow, "infoWindow");
  };

  const DefaultUserIcon = {
    url: employeeIcon,
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 15),
    scaledSize: new window.google.maps.Size(30, 30),
  };
  const UserIcon = {
    url: user.imgUrl,
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 15),
    scaledSize: new window.google.maps.Size(30, 30),
    shape: { coords: [17, 17, 18], type: "circle" },
    optimized: false,
    title: "spot",
    // shape: { coords: [50, 50, 18], type: "circle" },
  };

  const openInfoWindow = (user) => {
    setSelectId(user.id);
    setOpen(true);
  };
  const closeInfoWindow = () => {
    setOpen(false);
  };

  const divStyle = {
    // content: '<div class="mylabel">The label</div>',
    // position: new window.google.maps.LatLng(-32.0, 149.0),
    // shadowStyle: 1,
    padding: "5px",
    textAlign: "center",
    // width:"100px",
    // height:"40px"
    // backgroundColor: 'rgb(57,57,57)',
    // borderRadius: 5,
    // arrowSize: 10,
    // borderWidth: 1,
    // borderColor: '#2c2c2c',
     disableAutoPan: false,
     hideCloseButton: false,
    // arrowPosition: 30,
    // backgroundClassName: 'transparent',
    // arrowStyle: 2
    // padding: 15
  };
  const onLoad = infoWindow => {
   // console.log('infoWindow: ', infoWindow)
  }

  return (
    <>
      <div id="infhobox" className="overlaps">
        <Marker
          position={{
            lat: user.endPoint.latitude,
            lng: user.endPoint.longitude,
          }}
          icon={
            isEmployee && user.imgUrl !== null
              ? UserIcon
              : isClient
              ? null
              : DefaultUserIcon
          }
          onClick={() => openInfoWindow(user)}
        >
          
        </Marker>
        <OverlayView
          position={{
            lat: parseInt(user.startPoint.latitude),
            lng: parseInt(user.startPoint.longitude),
          }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          onLoad={onLoadInfo}
        >
          {/* <div
          style={{
            background: `var(--clr-black)`,
            color: `var(--clr-white)`,
            padding: `7px 12px`,
            fontSize: `11px`,
            borderRadius: `4px`,
          }}
        >
          {user.name}
        </div> */}
          <div>{user.userName}</div>
        </OverlayView>
      </div>
    </>
  );
};

export default UserWithLabel;
